import React from "react";
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Legend);

const QuartileGraph = (props) => {


  const data = {
    labels: ["Q1", "Q2", "Q3", "Q4"],
    datasets: [
      {
        labels: "364",
        data: props.quartileEngagement,
        backgroundColor: ["#8DC0F1", "#5BA4EB", "#328DE6", "#1974CE"],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        suggestedMax: 50,
        display: true,
        ticks: {
          color: "#141415",
          stepSize: 10,
          beginAtZero: true,
        },
        grid: {
          color: "#141415",
          display: false,
        },
      },
      x: {
        grid: {
          color: "#EAEAEB",
        },
      },
    },
  };

  return (
    <div className="engagement-attension-card h-100 quartile-graph-margin-top">
      <h5>
        Engagements in each Quartile
      </h5>
      <div className="row pt-4">
        <div className="col">
          <Bar options={options} data={data}></Bar>
        </div>
      </div>
    </div>
  );
};

export default QuartileGraph;
